import React from "react";
import { MdInsertComment } from "react-icons/md";
import AttachmentPopover from "../../../pages/employee_details/InvestmentsAndProofs/components/AttachmentPopover";
import ApprovalField from "./ApprovalField";

const InvestmentApprovalSection = ({
  title,
  investments = [],
  attachments,
  onFileSelect,
  onAddMoreAttachments,
  onRemoveAttachment,
  onOpenImage,
  openPopoverKey,
  setOpenPopoverKey,
  onCommentClick,
  onApproval,
  onRejection,
  isApproving,
  isRejecting,
  keyPrefix,
  getIdParams,
}) => {
  if (!investments || investments.length === 0) return null;

  const totalDeclared = investments.reduce((sum, inv) => sum + parseFloat(inv.amount), 0);
  const totalApproved = investments.reduce((sum, inv) => sum + parseFloat(inv.amount_approved || 0), 0);

  return (
    <>
      <p className="text-lg mx-3 font-semibold">{title}</p>
      <p className="mx-3 mt-1 mb-4 text-sm">
        Declared Amount: ₹{totalDeclared.toLocaleString()} | Approved Amount: ₹{totalApproved.toLocaleString()}
      </p>
      {investments.map((investment, index) => (
        <div key={investment[Object.keys(getIdParams(investment))[0]]} className="flex items-center mx-3 my-3">
          <div className="flex-no-grow-no-shrink px-1.5 w-[28.4%]">
            <p>{investment.label}</p>
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%]">
            <p className="text-right text-sm">₹{parseFloat(investment.amount).toLocaleString()}</p>
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
            <AttachmentPopover
              attachmentKey={`${keyPrefix}-${index}`}
              attachments={attachments}
              onFileSelect={() =>
                onFileSelect(
                  `${keyPrefix}-${index}`,
                  getIdParams(investment),
                  investment.document_count
                )
              }
              onAddMoreAttachments={onAddMoreAttachments}
              onRemoveAttachment={onRemoveAttachment}
              onOpenImage={onOpenImage}
              openPopoverKey={openPopoverKey}
              setOpenPopoverKey={setOpenPopoverKey}
              documentCount={investment.document_count}
            />
          </div>
          <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
            <button
              onClick={() =>
                onCommentClick(`${keyPrefix}-${index}`, getIdParams(investment))
              }
              className="flex items-center"
            >
              <MdInsertComment className="w-5 h-5 text-neutral-600" />
              {investment.comment_count > 0 && (
                <span className="ml-1 text-xs text-gray-600">
                  {investment.comment_count}
                </span>
              )}
            </button>
          </div>
          <ApprovalField
            approvedAmount={investment.amount_approved}
            actualAmount={parseFloat(investment.amount)}
            onApproval={onApproval}
            onRejection={onRejection}
            approvalParams={getIdParams(investment)}
            isApproving={isApproving}
            isRejecting={isRejecting}
            status={investment.status}
          />
        </div>
      ))}
      <hr className="my-5 mx-3" />
    </>
  );
};

export default InvestmentApprovalSection;
